import { useContext, useState } from 'react'
import { Paper, Typography, useMediaQuery, Button } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { ChromePicker } from 'react-color'

import { VibioThemeContext } from '../../../../../context/VibioThemeProvider'

export default function IconDesign({ themeId, iconColor }) {
    const isMobile = useMediaQuery('(max-width:1050px)')
    const [socialIconColor, setSocialIconColor] = useState(`#${iconColor}`)
    const [showColorPicker, setShowColorPicker] = useState(false)
    const [showUpdateSuccess, setShowUpdateSuccess] = useState(false)
    const { saveThemeChange } = useContext(VibioThemeContext)

    const styles = {
        paper: { p: 4, m: isMobile ? 0 : 2, mt: '1rem', borderRadius: '30px' },
        heading: { fontWeight: 600, fontFamily: 'inherit' },
        successText: { fontWeight: 500, fontFamily: 'inherit', color: 'green', margin: '0 1rem', display: 'inline' },
        label: { fontWeight: 500, fontFamily: 'inherit', margin: '1rem 1rem 1rem 0rem' },
        colorButton: { display: 'flex', justifyContent: 'center', alignItems: 'center', alignSelf: 'center', padding: 0, height: '32px', backgroundColor: 'transparent', color: '#000', border: '.8px solid #aaa', borderRadius: '16px', '&:hover': { border: '.8px solid #aaa' } },
        colorPreview: { padding: '10px', background: socialIconColor, border: '1px solid #000', borderRadius: '10px' },
        resetButton: { display: 'flex', justifyContent: 'center', alignItems: 'center', alignSelf: 'center', backgroundColor: '#fcfcfc', color: '#0a0a0a', borderRadius: '14px', textTransform: 'none', fontSize: '.68rem', fontFamily: 'inherit', border: '1px solid #aaa', '&:hover': { backgroundColor: '#f0f0f0', border: '1px solid #aaa' } },
        chromePicker: { position: 'absolute', zIndex: 1000 },
        section: { display: 'flex', flexDirection: 'row', justifyContent: 'start', alignContent: 'center' },
    }

    const handleSocialIconColorChange = (newIconColor) => {
        setSocialIconColor(newIconColor)
        saveThemeChange({ iconColor: newIconColor.slice(1) })
        setShowUpdateSuccess(true)
        setTimeout(() => setShowUpdateSuccess(false), 550)
    }

    const handleResetSocialIconColor = () => {
        setSocialIconColor("#fff")
        saveThemeChange({ iconColor: "x" })
        setShowUpdateSuccess(true)
        setTimeout(() => setShowUpdateSuccess(false), 550)
    }

    return (
        <Paper elevation={3} sx={styles.paper}>
            <Typography variant="h6" component="h6" sx={styles.heading}>
                Social Icons
                {showUpdateSuccess && <Typography variant="body1" component="p" sx={styles.successText}>Change saved!</Typography>}
            </Typography>

            <section style={styles.section}>
                <Typography variant="body1" component="p" sx={styles.label}>Icon Color</Typography>
                <Button variant='outlined' endIcon={<KeyboardArrowDownIcon />} onClick={() => setShowColorPicker(!showColorPicker)} sx={styles.colorButton}>
                    <div style={styles.colorPreview}></div>
                </Button>
            </section>

            <section style={styles.section}>
                <Button variant='outlined' onClick={handleResetSocialIconColor} sx={styles.resetButton}>
                    Reset Icon Colors
                </Button>
            </section>

            {showColorPicker && <div style={styles.chromePicker}>
                <ChromePicker color={socialIconColor} onChange={color => handleSocialIconColorChange(color.hex)} />
            </div>}
        </Paper>
    )
}
